import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import ScrollToTopButton from './ScrollToTopButton'; 
import '../assets/css/Footer.css';
import WhatsAppButton from "./WhatsAppButton";
import logo from '../assets/img/logo.png';
import qr from '../assets/img/qr-code.png';
import insta from '../assets/img/icon1.svg';
import tiktok from '../assets/img/tiktok.svg';
import fb from '../assets/img/icon3.svg';

const Footer = () => {
  const location = useLocation();

  // Check if the current route is not the home page
  const isInnerPage = location.pathname !== '/';
  return (
    <footer className={isInnerPage ? 'footer-inner' : 'footer-default'}>
      <Container>
        <Row>
          {/* Column 1 */}
          <Col md={3} sm={6} className="mb-4">
            <div className='widget-logo pt-5'>
              <img src={logo} alt="sunrise logo" className="logo" />
            </div>
          </Col>

          {/* Column 2 */}
          <Col md={3} sm={6} className="mb-4">
          <div className='widget'>
            <h5>Quick links</h5>
            <ul className="list-unstyled">
              <li><a href="/about">About us</a></li>
              <li><a href="/service">Services</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/career">Career</a></li>
            </ul>
            </div>
          </Col>

          {/* Column 3 */}
          <Col md={3} sm={6} className="mb-4">
          <div className='widget '>
            <h5>Contact info</h5>
            <ul className="contact-info">
              <li><span>Address:   1591 John F Kennedy Blvd Jersey City, NJ 07305</span></li>
              <li><span>Email:  <a href="mailto:info@vstrongcontractor.com">info@vstrongcontractor.com</a></span></li>
            </ul>
            <ul className="social-icon d-flex">
              <li><a href="https://www.facebook.com/share/12EEWTDTQkW/?mibextid=LQQJ4d" className="text-light me-3" target='_blank'>
              <img src={fb} alt="facebook" className="" /></a></li>

              <li><a href="https://www.instagram.com/vstrongcontractor?igsh=Nms5bDB1aWtoNmI%3D&utm_source=qr" className="text-light me-3" target='_blank'>
              <img src={insta} alt="instagram" className="" /></a></li>

              <li><a href="https://www.tiktok.com/@vstrong.contracto?_t=8s680Axyj7u&_r=1" className="text-light me-3" target='_blank'>
              <img src={tiktok} alt="tiktok" className="" /></a></li>

              {/* <li><a href="#twitter" className="text-light me-3">
              <img src={youtube} alt="youtube" className="" /></a></li> */}
              
            </ul>
            </div>
          </Col>

          {/* Column 4 */}
          <Col md={3} sm={6} className="mb-4">
          <div className='widget widget-product'>
          <h5>QR Code</h5>
          <img src={qr} alt="sunrise logo" className="logo" />
            </div>
          </Col>
        </Row>
  
        <Row className="copyright-bar">
          <Col className='d-flex align-item-center justify-content-between'>
            <p className="text-center mb-0">Copyright © 2024 The <span> V STRONG CONTRACTOR LLC </span></p>
            <p className="text-center mb-0">Designed by <a href="https://www.aspirewebs.com/">Aspirewebs & Informatics Pvt Ltd</a></p>
          </Col>
        </Row>
      </Container>
      <WhatsAppButton />
      <ScrollToTopButton />
    </footer>
    
  );
};

export default Footer;
